import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { fluidType } from 'Shared/common/FluidType';
import { merge } from 'Shared/common/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { Imbue } from 'Shared/frontend/fonts/Imbue';
import { INav } from 'Common/config/INav';
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';
import {PeopleCircle} from 'Shared/frontend/icons/PeopleCircle'; 
import {PeopleCircle as BackendPeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 


export class FamilySettings extends BaseSettings
{
	palette()
	{
		return{
			background: '#f6e9d2',//FamilyTan
			text: '#503014',
			inverseText: '#ffffff',
			feature: '#cf1413', //FamilyRed
			feature2: '#503014', //FamilyBrown 

			/* Eg the mobile nav colour */
			dimBackground: '#FDFAE7',
		};
	}

	fontIncludes()
	{
		return [
			Imbue
		];
	}

	fontsText()
	{
		return({
			fontFamily: 'serif',
			fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,23),		
		})
	}

	fontsHeading()
	{
		return({
			fontFamily: '"Imbue", serif',
			letterSpacing: 3,
			color: this.palette().feature,	
			lineHeight: 1.1,
			fontWeight: '500',
		})
	}

	fontsHeading2()
	{
		return({
			fontFamily: '"Questrial", sans-serif',
			color: this.palette().text,
			fontWeight: '300',
			lineHeight: 1,
		})
	}
	//used on Teaser,Title,Tagline so they layout evenly and collapse when needed
	textMargins()
	{
		return({
			margin: '.2em 0',
		})
	}

	fonts()
	{
		return {
			text: 'serif',
			heading: '"Imbue", serif', 
			subNav:  'serif',
			buttons:  'serif',
			desktopNav:  '"Imbue", serif',
			mobileNav:  '"Imbue", serif',
		};
	}

	text()
	{
		return merge(super.text(), {
			
			pageTitle: {
				...this.fontsHeading(),
				textTransform: 'uppercase',
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,25,60),
		
			},
			title: {
				...this.fontsHeading(),
				textTransform: 'uppercase',
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,25,60),
			},
			plain: {
				...this.fontsText(),
			},

			teaser: {
				...this.fontsHeading(),
				...this.textMargins(),
				textTransform: 'uppercase',
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,36),
			},
			tagline: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,33),	
				
			},

			subtitle: {
				...this.fontsHeading(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,40),
		
				
			},
		});
	}

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					backgroundColor: this.palette().dimBackground,
					...this.fontsText(),
					lineHeight: 1.1,
					color: this.palette().text,
					
				},
				dateBar: {
					backgroundColor: this.palette().background,
					...this.fontsText(),
					fontSize: '16px',
					color: this.palette().text,
					
				},

			},
		});
	}

	page()
	{
		const sizes = this.sizes();

		return merge(super.page(),{

			body: {
				...this.fontsText(),
			},

			nav: {
				desktop: {
					settings: {
						subNav: {
							backgroundColor: '#ff9b9a'
						}
					}
				}
			},

			header: {
				mobile: {
					display: 'flex',
					justifyContent: 'center'
				},
				logo: {
					width: fluidType('px',sizes.endFontShrink,sizes.maxPageWidth,80,150)
				}
			},

			heading: {
				color: this.palette().feature,
			},
			
			section: {},

			button: {
				backgroundColor: this.palette().feature,
				// /borderRadius: '0.4em',
				color: this.palette().inverseText,
				fontSize: 20,
				letterSpacing: 2,
				padding: 10,
			},

			widgets: {
				scrollStyle:{
					scrollbarColor: '#f6e9d2 white !important',
				},
				overlay: {

					'.text-teaser':{
						fontWeight: '700',
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,24,32),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,		
					},
					'.text-title': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,50,100),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},

					'.text-tagline': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,22,36),
						fontWeight: '300',
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
					'.text-subtitle': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,55),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
					'.text-plain': {
						//fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,64),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
				},
				subNav: {
					button: {
						backgroundColor: this.palette().text
					}
				},
			},

		});
	}

	nav()
	{
		const palette = this.palette();
		return merge(super.nav(),{
			
			desktop:{
				settings: {
					outer: {
						background: this.palette().background,
					},
					button: {
						...this.fontsHeading(),
						color: palette.feature,
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,40),
				
						':hover': {
							color: palette.text
						}
					},
					active: {
						color: palette.text,
					}
				}
			},

			mobile:{		
				overlay:{
					background: palette.background,
				
					button:{
					fontFamily: '"Imbue", sans-serif',
					},
				
				},
				
				
		
				button:{
					color: palette.text,
					background: palette.background,

					// Ask ben need to do importants to overwrite SVG formula on MobileFooter Nav
					//search fill: isActive ? theme().nav.mobile.active.color : palette().text
					svg:{
						fill: `${palette.text} !important`
					},

					':hover': {
			//TODO cf remove from BaseTheme?						
		//						color: this.palette().inverseText,
						backgroundColor: `hsl(from ${this.palette().background} h calc(s + 15) calc(l + 15))`
					}
				},
				active: {
					color: palette.feature,
					svg:{
						fill: `${palette.feature} !important`
					},
				},
				more: {
					root: {
						backgroundColor: palette.background,

					},
					button: {
						color: this.palette().text,
						':hover': {
							color: this.palette().feature,
							backgroundColor: `hsl(from ${palette.background} h calc(s + 15) calc(l + 15))`
						}
					}
				}
			},

		})
	}

	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		/* base.specials = {
			general: 'General',
			beers: 'Beers'
		};
		*/

		const settings = merge(base, <DeepPartial<BaseThemeType>>{

			event: {
				subNav: {
					button:{
						background: palette.feature,
						color: palette.inverseText,
						fontSize:20,
						padding: 10,
					}
				},

				heading: {
					...this.fontsHeading2(),
					fontSize: '2em',
					lineHeight: 1.1,
					textTransform:'uppercase',
				},
				artist: {
					heading: {
						color: palette.feature,
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {
				subNav: {
					button: {
						color: palette.feature,
						border: 'solid 3px',
						borderColor: palette.feature,
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,23),
						textTransform: 'uppercase',
					},
					buttonType: type => ({ backgroundColor: palette.background })
				},
				section: {
					marginBottom: '3em'
				},
				item: {
					type: 'imageless',
					title: { 
					...this.fontsText(),
					},
				},
			},

			subNavButton: {
				borderRadius: '0.4em'
			},
		});
		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}

	pages()
	{
		return [
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'dine',
				frontend: {
					route: '/dine',
					metaTitle: 'Dine'
				},
				backend: {
					route: '/dine',
					title: 'Dine'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
			{
				key: 'stay',
				frontend: {
					route: '/stay',
					metaTitle: 'Stay'
				},
				backend: {
					route: '/stay',
					title: 'Stay'
				}
			},
			{
				key: 'vouchers',
				frontend: {
					route: '/vouchers',
					metaTitle: 'Vouchers'
				},
				backend: {
					route: '/vouchers',
					title: 'Vouchers'
				}
			},
			
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menus',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Dine',		page:'dine'},
				{label:'Contact',	link:'frontend/Contact'},

				{label:'More',	items: [ 
					{label:'Hire',		link:'frontend/Hire'},
					{label:'Stay',		page:'stay'},
					{label:'Vouchers',	page:'vouchers'},
				]},
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon:Home},
					{label:'Menus',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon:Calendar},
					{label:'Dine',		page:'dine',				icon:PeopleCircle},
					{label:'Contact',	link:'frontend/Contact',	icon:Contact},
					{label:'Hire',		link:'frontend/Hire', 		icon:Contact},
					{label:'Stay',		page:'stay',				icon:Contact},
					{label:'Vouchers',	page:'vouchers',			icon:Home},
				]
			}
		};
	}

	backendNavContent()
	{
		return [
			...super.backendNavContent(),
			{label:'Staff',		route:'/admin/staffResources',	icon:BackendPeopleCircle},
		];
	}

	backendEvent()
	{
		return merge(super.backendEvent(), {
			calendar: {
				singleEvent: {
					defaultStart: {
						hour: 19,
						minute: 0
					}
				}
			}
		});
	}
}
